// extracted by mini-css-extract-plugin
export var label = "_bj-1";
export var reminder = "_bj-0";